import { useState } from 'react';
import { paginate } from 'utils/pagination-utils';

export function usePagination(limit: number) {
  const [currentPage, setCurrentPage] = useState(1);
  const [from, setFrom] = useState(0);
  const [to, setTo] = useState(limit);

  const handlePagination = (page: number) => {
    paginate({
      page,
      limit,
      onPageChange: setCurrentPage,
      onRangeChange: (from, to) => {
        setFrom(from);
        setTo(to);
      },
    });
  };

  return {
    currentPage,
    from,
    to,
    setCurrentPage,
    handlePagination,
  };
}